var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('Search',{attrs:{"msg":"个人中心"}}),_c('div',{staticClass:"con w-1920"},[_c('div',{staticClass:"center w-1200"},[_c('Left_menu'),_c('router-view')],1)]),_c('div',{staticClass:"kongbai"}),_c('Foot'),_c('Cart')],1)}
var staticRenderFns = []

export { render, staticRenderFns }